<script>

    import vSelect from "vue-select"

    export default {
        name: 'symForm',
        components: {vSelect},
        props: {
            form: {
                Type: String,
                Default: ''
            },
	        data: {
                Type: Array
	        },
	        options: {
                Type: Array
	        },
            formProcess: {
                Type: String,
                Default: ''
	        },
            errors: {
                Type: Array
            }
        },
        methods: {
	        getForm (form) {
                    var elements = document.getElementById("form").elements;
                    var obj ={};
                    for(var i = 0 ; i < elements.length ; i++){
                        var item = elements.item(i);
                        obj[item.name] = item.value;
                    }
                    return obj;
	        },
            getFormValues (submitEvent) {
                submitEvent.preventDefault();

                this.data = this.serialize(submitEvent.target);
                this.$emit('sended', this.data);
            },
            serialize (form) {
                var field, s = {};
                if (typeof form == 'object' && form.nodeName == "FORM") {
                    var len = form.elements.length;
                    for (var i=0; i<len; i++) {
                        field = form.elements[i];
                        if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                            if (field.type == 'select-multiple') {
                                for (j=form.elements[i].options.length-1; j>=0; j--) {
                                    if(field.options[j].selected)
                                        s[field.name] = field.value;
                                }
                            } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                                s[field.name] = field.value;
                            }
                        }
                    }
                }
                return s;
            }
        },
        created () {

            this.$options.template = '<div class="text-left">'+this.form+'</div>';

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/form/symForm.vue